import { Box, Card, CardContent, Typography } from "@mui/material";
import { motion } from "framer-motion";
import * as Icons from "@mui/icons-material";

const stats = [
    {
        title: "Ventas del día",
        value: "$12,450",
        icon: "PointOfSale",
        color: "#6366f1"
    },
    {
        title: "Órdenes",
        value: "34",
        icon: "ReceiptLong",
        color: "#22c55e"
    },
    {
        title: "Productos",
        value: "128",
        icon: "Inventory2",
        color: "#f59e0b"
    },
    {
        title: "Stock bajo",
        value: "5",
        icon: "Warning",
        color: "#ef4444"
    }
];

const Dashboard = () => {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                gap: 2
            }}
        >
            {stats.map((s, i) => {
                const Icon = Icons[s.icon] || Icons.FiberManualRecord;

                return (
                    <Card
                        key={i}
                        component={motion.div}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: i * 0.05 }}
                        sx={{
                            backgroundColor: '#020617',
                            border: '1px solid rgba(255,255,255,0.08)',
                            borderRadius: 3,
                            color: '#e5e7eb'
                        }}
                    >
                        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Box
                                sx={{
                                    width: 48,
                                    height: 48,
                                    borderRadius: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: `${s.color}22`
                                }}
                            >
                                <Icon sx={{ color: s.color }} />
                            </Box>

                            <Box>
                                <Typography sx={{ fontSize: 12, color: '#94a3b8' }}>
                                    {s.title}
                                </Typography>
                                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                    {s.value}
                                </Typography>
                            </Box>
                        </CardContent>
                    </Card>
                );
            })}
        </Box>
    );
};

export default Dashboard;